import { render, staticRenderFns } from "./StaffTarget.vue?vue&type=template&id=70809d98&"
import script from "./StaffTarget.vue?vue&type=script&lang=js&"
export * from "./StaffTarget.vue?vue&type=script&lang=js&"
import style0 from "./StaffTarget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports